import type { BlockDto, ImageDto } from '@klickibunti/pagebuilder-react';
import type { BlocksContent } from '@strapi/blocks-react-renderer';

export interface HeroConfig {
  title?: string;
  backgroundImage?: ImageDto;
  /** Entity-image token, e.g. `{city.image}` — resolved website-side and,
   * when it yields an image, overrides `backgroundImage`. */
  backgroundOverride?: string;
  /**
   * Optional seal image, CMS-managed (SH-411). Variant A renders it beside the
   * h1; B and C as a corner overlay. Rendered only when set, and never gated
   * on the location's certification status.
   *
   * Its accessible name comes from the media's `alternativeText` (see
   * `imageAlt`), which `types/pagebuilder-image.d.ts` adds to the shared
   * `ImageDto` — this field used to widen it on its own.
   */
  seal?: ImageDto;
  content?: BlockDto[];
  badgeText?: string;
  /**
   * Rich-text badge wording (SH-424). Takes precedence over `badgeText`
   * whenever it carries content, and needs no price placeholder — which is
   * what lets the badge appear on pages that have no location entity.
   */
  badgeRichText?: BlocksContent;
}

export type HeroResolved = HeroConfig;

/**
 * `alt` used when the seal media carries no `alternativeText`. The seal is
 * meaningful content, so an empty `alt` would hide it from screen readers
 * entirely (SH-411).
 */
export const SEAL_ALT_FALLBACK = 'Zertifikat';
